<script>
import {AlertService} from "@/services/AlertService";
import {mapActions} from "vuex";
import requestLoaderMixin from "@/mixins/requestLoaderMixin";

export default {
  name: "ModuleFeature",
  mixins : [
    requestLoaderMixin
  ],
  props :{
    feature : {
      type : Object,
      default : null
    }
  },
  data() {
    return {
      copiedFeature : {
        email_settings : {
          is_included : 0,
          is_to : 0,
          is_cc : 0,
        }
      },
      is_included : false,
      selectedOption : '',
      disabledFields : true
    }
  },
  methods : {
    ...mapActions('EmailModule', [
      'getEmailById',
      'updateEmailModuleFeature'
    ]),
    setDisabledFields(value) {
      this.disabledFields = value;
    },
    changeSelectedOption() {
      if (this.is_included === false) {
        this.selectedOption = '';
      }
    },
    initialize() {
      this.is_included = false;
      this.selectedOption = '';

      if (!this.feature?.email_settings) {
        this.copiedFeature.email_settings.is_included = 0;
        this.copiedFeature.email_settings.is_to = 0;
        this.copiedFeature.email_settings.is_cc = 0;
      } else {
        this.copiedFeature.email_settings.is_included = this.feature?.email_settings.is_included;
        this.copiedFeature.email_settings.is_to = this.feature?.email_settings.is_to;
        this.copiedFeature.email_settings.is_cc = this.feature?.email_settings.is_cc;
      }

      this.is_included = this.copiedFeature?.email_settings?.is_included === 1;

      if (this.is_included) {
        if (this.copiedFeature.email_settings.is_to === 1) {
          this.selectedOption = 'is_to';
        } else if (this.copiedFeature.email_settings.is_cc === 1) {
          this.selectedOption = 'is_cc';
        }
      }
    },
    async cancelEdit() {
      this.initialize();
    },
    async saveChanges() {
      const response = await this.updateEmailModuleFeature(this.params);

      if (response.result === false) {
        return false;
      }


      this.copiedFeature.email_settings.is_included = this.is_included === true ? 1 : 0;
      this.copiedFeature.email_settings.is_to = 0;
      this.copiedFeature.email_settings.is_cc = 0;
      if (this.selectedOption === 'is_to') {
        this.copiedFeature.email_settings.is_to = 1;
      } else if (this.selectedOption === 'is_cc') {
        this.copiedFeature.email_settings.is_cc = 1;
      }
    }
  },

  watch: {
    feature: {
      handler() {
        this.initialize();
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    params() {
      const payload = {
        email_id : parseInt(this.$route.params.email_id),
        module_feature_id : this.feature.id,
        is_included : this.is_included === true ? 1 : 0
      };

      if (this.selectedOption === 'is_to') {
        payload.is_to = 1;
        payload.is_cc = 0;
      } else if (this.selectedOption === 'is_cc') {
        payload.is_to = 0;
        payload.is_cc = 1;
      } else {
        payload.is_to = 0;
        payload.is_cc = 0;
      }
      return payload;
    },
    disableSaveButton() {
      return this.params.is_included === 1 && this.params.is_to === 0 && this.params.is_cc === 0;
    },
    hasChanges() {
      const isIncludedChanged = (this.copiedFeature?.email_settings?.is_included ?? 0) !== this.params.is_included;
      const isToChanged = (this.copiedFeature?.email_settings?.is_to ?? 0) !== this.params.is_to;
      const isCCChanged = (this.copiedFeature?.email_settings?.is_cc ?? 0) !== this.params.is_cc;

      return isIncludedChanged || isToChanged || isCCChanged;
    },
    canClickSaveButton() {
      return !(this.hasChanges === false || this.disableSaveButton)
    }
  },
}
</script>

<template>
  <div class="p-3 col-xl-6 col-lg-6 col-md-12">
    <div class="card p-2">
      <div class="row justify-content-between">
        <div class="col-auto">
          <h6 class="font-weight-bold text-uppercase">{{ feature?.name }}</h6>
        </div>
      </div>



      <div class="row align-items-center no-gutters">
        <div class="col-lg-9 p-0">
          <div class="form-check">
            <input class="form-check-input checkbox-input"
                   type="checkbox"
                   :id="feature.id"
                   v-model="is_included"
                   @change="changeSelectedOption"
                   :disabled="disabledFields"
            >
            <label :for="feature.id" class="module_label font-weight-bold col-form-label no-select cursor-pointer"> Included </label>
          </div>
        </div>
      </div>

      <div class="row align-items-center no-gutters ml-2">
        <div class="col-lg-9 p-0">

          <div class="form-check form-check-inline mr-3">
            <input
              class="form-check-input checkbox-input"
              type="radio"
              :name="`${feature.id}_is_to`"
              :id="`${feature.id}_is_to`"
              value="is_to"
              v-model="selectedOption"
              :disabled="is_included === false || disabledFields"
            >
            <label
              class="form-check-label module_label font-weight-bold no-select cursor-pointer"
              :for="`${feature.id}_is_to`"
            >
              TO
            </label>
          </div>

          <div class="form-check form-check-inline">
            <input
              class="form-check-input checkbox-input"
              type="radio"
              :name="`${feature.id}_is_cc`"
              :id="`${feature.id}_is_cc`"
              value="is_cc"
              v-model="selectedOption"
              :disabled="is_included === false || disabledFields"
            >
            <label
              class="form-check-label module_label font-weight-bold no-select cursor-pointer"
              :for="`${feature.id}_is_cc`"
            >
              CC
            </label>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
